import debounce from 'lodash.debounce';
import { mapGetters, mapState } from 'vuex';
import { FILTERS_SEARCHING } from '@/constants/filtersModelNames';

export default {
    data: () => ({
        debouncedGetSiteGroups: null,
        isSiteGroupsLoading: false,
        searchSiteGroups: null,
        siteGroupsPaginationPage: 1
    }),
    computed: {
        ...mapState('sites', [
            'totalSiteGroupsAmount'
        ]),
        ...mapGetters('sites', [
            'siteGroups'
        ])
    },
    watch: {
        searchSiteGroups: {
            handler (val, oldVal) {
                if (!val || this.isSiteGroupsLoading || val === oldVal) {
                    return;
                }

                this.debouncedGetSiteGroups(val);
            }
        }
    },
    methods: {
        getSiteGroups (val) {
            this.isSiteGroupsLoading = true;

            const params = {};

            if (val) {
                params.search = val;
            }

            return this.$store.dispatch('sites/getSiteGroups', params)
                .then(() => {
                    this.siteGroupsPaginationPage = 1;
                })
                .finally(() => {
                    this.isSiteGroupsLoading = false;
                });
        },
        getSiteGroupsLazyLoading () {
            if (this.totalSiteGroupsAmount > this.siteGroups.length) {
                this.isSiteGroupsLoading = true;

                this.siteGroupsPaginationPage += 1;

                const params = {
                    'page': this.siteGroupsPaginationPage
                };

                const _name = this.searchSiteGroups || this.filtersSearching?.[FILTERS_SEARCHING.SITE_GROUPS];

                if (_name) {
                    params.search = _name;
                }

                return this.$store.dispatch('sites/getSiteGroupsLazyLoading', params)
                    .finally(() => {
                        this.isSiteGroupsLoading = false;
                    });
            }
        }
    },
    created () {
        this.debouncedGetSiteGroups = debounce(this.getSiteGroups, 1000);
    }
};
